import axiosInstance from './axiosInstance';

const BASE_URL = '/Corrohealth/api/email-preferences';

export const EMAIL_PREFERENCE_MODULES = [
  {
    key: 'ROOM_BOOKING',
    label: 'Room Booking',
    description: 'Booking confirmations, approvals, rejections, and admin alerts',
  },
  {
    key: 'HELPDESK',
    label: 'Helpdesk',
    description: 'Ticket created, status updates, assignment, and comment notifications',
  },
];

export const emailPreferencesApi = {
  /**
   * Returns { ROOM_BOOKING: false, HELPDESK: true }
   * false = opted IN (receiving emails), true = opted OUT
   */
  getPreferences: async () => {
    const response = await axiosInstance.get(BASE_URL);
    return response.data?.data || {};
  },

  /**
   * Toggle a module preference.
   * optedOut: true = stop emails, false = resume emails
   */
  updatePreference: async (module, optedOut) => {
    const response = await axiosInstance.put(`${BASE_URL}/${module}`, { optedOut });
    return response.data?.data;
  },
};
